import 'swiper/swiper.scss';

export function ItemList({ ListSwiperComp, ListPlainComp, ...props }) {
    if (props.list.length > 3) {
        return <ListSwiperComp {...props} />;
    }

    return <ListPlainComp {...props} />;
}
